export default ['Welcome', 'Questionnaire', 'Payment details', 'Confirmation']
